import { kuiperClassNames } from '@opallabs/kuiper'
import { ModularCarousel } from '../../../../../ModularCarousel'
import { MAX_PHOTOS, SECTION_COMPONENT_NAME } from '../../constants'
import { MobileSlide } from '../../slides/MobileSlide'
import { MOBILE, styles } from '../../styles'
import { DisplayProps } from '../../types'

const availableModules = [
  {
    component: MobileSlide,
    componentName: SECTION_COMPONENT_NAME,
    title: '',
  },
]

export const MobileSingle: React.FC<DisplayProps> = ({
  accountImage,
  accountName,
  content,
  isExpanded,
  isPresenting,
  isSnapshot,
  modules,
  onAddSection,
  onContentChange,
  onDeleteSection,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  onSoundChange,
  readOnly,
  sound,
  truncate,
  updateSectionPostOption,
}) => (
  <div
    css={styles.getMobileBaseStyles(isExpanded)}
    className={kuiperClassNames('tiktok tiktok-carousel tiktok-mobile-single')}
  >
    <ModularCarousel
      addComponentText="Add Photo"
      allProps={{
        accountImage,
        accountName,
        content,
        isSnapshot,
        onContentChange,
        onSoundChange,
        sound,
        truncate,
      }}
      availableModules={availableModules}
      carouselWidth={MOBILE.width}
      isExpanded={isExpanded}
      isPresenting={isPresenting}
      maxSections={MAX_PHOTOS}
      modules={modules}
      onAddSection={onAddSection}
      onDeleteSection={onDeleteSection}
      onDragDrop={onDragDrop}
      onExpandAsset={onExpandAsset}
      onRemoveAsset={onRemoveAsset}
      onShowAssetPicker={onShowAssetPicker}
      readOnly={readOnly}
      updateSectionPostOption={updateSectionPostOption}
    />
  </div>
)
